// SaaS tenant selection persisted for pre-login (branding + login) requests.
// After login the JWT carries the tenant, so this is only authoritative pre-auth.
const KEY = "cf_tenant";

export function getTenant() {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
}

export function setTenant(t) {
  if (t && t.slug) localStorage.setItem(KEY, JSON.stringify({ slug: t.slug, name: t.name, brand: t.brand }));
  else localStorage.removeItem(KEY);
}

export function clearTenant() { localStorage.removeItem(KEY); }
